import { useState } from "react";
import api from "../constant/api"; // Ungal dynamic API configuration instance path
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

 const handleSubmit = (e) => {
    e.preventDefault();

    // 🔴 Maps directly with app.use("/api/admin", adminUserFileRoute)
    api.post("/api/admin/login", form)
      .then(res => {
        // Safe check: data matrum success true-aa nu paarkkirom
        if (res.data && res.data.success) {
          
          // Double check: backend-il irundhu user object proper-aa varudha nu check seigirom
          if (res.data.user) {
            // 1. Save Token and User JSON Configuration safely
            localStorage.setItem("token", res.data.token || "mock-token-id");
            localStorage.setItem("user", JSON.stringify(res.data.user));

            // 2. Core Tracking: Accessing fields safely
            localStorage.setItem("userEmail", res.data.user.email || form.email);
            localStorage.setItem("userRole", res.data.user.role || "user");

            // 🚀 INSTANT SYNC TRIGGER: Reloads sidebar permitted menus
            window.dispatchEvent(new Event("settingsSaved"));

            alert("Login Success! 🎉");
            // 3. Go to main layout dashboard matrix
            navigate("/"); 
          } else {
            alert("Backend logic error: User data missing in response ❌");
          }

        } else {
          // Backend-il irundhu varum 'Invalid password credentials ❌' ippo inge alert-il theriya vendum
          alert(res.data.msg || "Login Failed ❌ Check credentials.");
        }
      })
      .catch(err => {
        console.error("Login process error:", err);
        alert("Server Error or Connection Refused ❌");
      });
  };

  return (
    <div className="flex items-center justify-center h-screen bg-slate-900/10">
      <form 
        onSubmit={handleSubmit} 
        className="bg-white p-8 rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.08)] border border-slate-100 w-85 transition-all"
      >
        <div className="mb-6 text-center">
          <h2 className="text-2xl font-black text-slate-800 tracking-wide uppercase">
            AK Portal
          </h2>
          <p className="text-xs font-bold text-indigo-500 uppercase tracking-widest mt-1">
            ✦ Admin Gateway
          </p>
        </div>

        <div className="space-y-4">
          {/* Email Input */}
          <div>
            <label className="block text-[11px] font-extrabold text-slate-500 uppercase tracking-wider mb-1.5 px-1">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email} // 👈 Added: Two-way binding connection
              placeholder="admin@ak.com"
              onChange={handleChange}
              required
              className="w-full border border-slate-200 p-3 text-sm rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 bg-slate-50/50"
            />
          </div>

          {/* Password Input */}
          <div>
            <label className="block text-[11px] font-extrabold text-slate-500 uppercase tracking-wider mb-1.5 px-1">
              Secret Password
            </label>
            <input
              type="password"
              name="password"
              value={form.password} // 👈 Added: Two-way binding connection
              placeholder="••••••••"
              onChange={handleChange}
              required
              className="w-full border border-slate-200 p-3 text-sm rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 bg-slate-50/50"
            />
          </div>
        </div>

        <button type="submit" className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 transition-all text-white w-full py-3.5 rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-indigo-600/20 active:scale-[0.98] mt-6">
          Authorize Login
        </button>
      </form>
    </div>
  );
}